import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=36e04c08&scoped=true&"
import script from "./step4.ts?vue&type=script&lang=js&"
export * from "./step4.ts?vue&type=script&lang=js&"
import style0 from "./step4.less?vue&type=style&index=0&id=36e04c08&lang=less&scoped=true&"
import style1 from "../smart-clip.less?vue&type=style&index=1&id=36e04c08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e04c08",
  null
  
)

export default component.exports